module.exports = __webpack_public_path__ + "img/Button_download.d89d48f3.svg";